import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import NextLink from '../NextLink';
import TitledLink from '../TitledLink';
import TitledBlock from '../TitledBlock';
import { colors } from '../../constants/styleConstants';
import { TP } from '../../constants/consts';
import { useTranslation } from '../../src/i18n';

const useStyles = makeStyles(() => ({
  description: {
    padding: '12px',
  },
  descriptionTitle: {
    fontSize: '15px',
    color: colors.primaryTitleColor,
  },
  tagLink: {
    padding: '3px 6px',
    lineHeight: 1,
    borderRadius: '10px',
    background: colors.websiteLinkColorBg,
    fontSize: '12px',
    marginRight: '7px',
    marginBottom: '5px',
  },
  tagLinkText: {
    fontSize: '12px',
    lineHeight: 1,
    color: colors.websiteLinkColor,
    '&:active': {
      opacity: 0.6,
    },
  },
  tagItem: {
    padding: 0,
    display: 'flex',
    flexWrap: 'wrap',
  },
  linkItem: {
    paddingRight: '0',
  },
}));

const ImageSlideDescription = ({ image }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const { descriptionTitle, tags, musicalWork, musicalWorkLinkProps, company, companyLinkProps } = image;

  return (
    <div className={classes.description}>
      {descriptionTitle && (
        <Grid item xs={12}>
          <span className={classes.descriptionTitle}>{descriptionTitle}</span>
        </Grid>
      )}
      {tags && tags.length !== 0 && (
        <TitledBlock contentClass={classes.tagItem} title={t(`${TP}.m_TAGS`)} titleColor="light" titleSize="small">
          {tags.map((tag, index) => (
            <NextLink key={index} className={classes.tagLink} {...tag.linkProps}>
              <span className={classes.tagLinkText}>{tag.linkText}</span>
            </NextLink>
          ))}
        </TitledBlock>
      )}
      {musicalWork && (
        <Grid item xs={12}>
          <TitledLink
            className={classes.linkItem}
            title={t(`${TP}.m_MUSICALWORK`)}
            titleColor="light"
            titleSize="small"
            linkText={musicalWork}
            linkProps={musicalWorkLinkProps}
          />
        </Grid>
      )}
      {company && (
        <Grid item xs={12}>
          <TitledLink
            className={classes.linkItem}
            title={t(`${TP}.m_COMPANY`)}
            titleColor="light"
            titleSize="small"
            linkText={company}
            linkProps={companyLinkProps}
          />
        </Grid>
      )}
    </div>
  );
};

ImageSlideDescription.propTypes = {
  image: PropTypes.shape({
    src: PropTypes.string,
    alt: PropTypes.string,
    tags: PropTypes.arrayOf(
      PropTypes.shape({
        linkText: PropTypes.string,
        linkProps: PropTypes.oneOfType([PropTypes.shape({ ...NextLink.propTypes }), PropTypes.func]),
      }),
    ),
    descriptionTitle: PropTypes.string,
    musicalWork: PropTypes.string,
    musicalWorkLinkProps: PropTypes.shape(NextLink.propTypes),
    company: PropTypes.string,
    companyLinkProps: PropTypes.shape(NextLink.propTypes),
  }),
};

export default ImageSlideDescription;
